import { Grid, Heading, Text } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import PaymentOverviewPage from '../paymentoverview'
import { Divider } from '../styles'
import { StyledPackageInformation } from './styles'
import { PropsPackageInformationTemplate } from './props'

const PackageInformationTemplate = ({
    basisType,
    packageName,
    partnerName,
    packageService,
    customer,
}: PropsPackageInformationTemplate): ReactElement => {
    const { t } = useTranslation()

    const bookingPartner = (
        <Text primary>
            {t(`common:basistypes.${basisType.id}.singularis`)}:{' '}
            <Text bold>{partnerName}</Text>
        </Text>
    )
    const packageText = (
        <Text primary>
            {t('checkout.paymentoverview.package')}:{' '}
            <Text bold>{packageService}</Text>
        </Text>
    )

    const nameText = (
        <Text primary>
            {t('common:name')}: <Text bold>{customer.name}</Text>
        </Text>
    )

    const emailText = (
        <Text primary>
            {t('common:email')}: <Text bold>{customer.email}</Text>
        </Text>
    )
    const phoneText = (
        <Text primary>
            {t('common:phone')}: <Text bold>{customer.phone}</Text>
        </Text>
    )

    return (
        <StyledPackageInformation>
            <Grid gap={16}>
                <Grid>
                    <Heading bold primary size={2}>
                        {packageName}
                    </Heading>
                </Grid>
                <Grid gap={'16'}>
                    <Grid>
                        {packageText}
                        {bookingPartner}
                    </Grid>
                    <Divider />
                    <Grid>
                        {nameText}
                        {emailText}
                        {phoneText}
                    </Grid>
                </Grid>
            </Grid>
        </StyledPackageInformation>
    )
}

export default PackageInformationTemplate
